const state = {
  patientData: {},
  userData: {},
};

export default state;
